import startsWithSubDirectory from "./startsWithSubDirectory";
import { getEnv } from "@/env";

const coursePaths = ["course", "learn", "executive-education", "boot-camps"];
const programPaths = [
  "program",
  "bachelors",
  "masters",
  "micromasters",
  "microbachelors",
  "gfa",
  "professional-education",
  "xseries",
  "professional-certificate",
  "doctorate",
  "license",
  "certificates",
];

const getWebviewUrl = (url: string) => {
  const SITE_DOMAIN = getEnv("NEXT_PUBLIC_SITE_URL", "https://www.edx.org");

  const isExternalUrl = url.startsWith("http://") || url.startsWith("https://");
  const urlObj = isExternalUrl ? new URL(url) : new URL(url, SITE_DOMAIN);
  const urlPath = urlObj.pathname.slice(1); // remove leading "/"
  const urlSearch = urlObj.search ? urlObj.search.slice(1) : "";

  // Handle special case: authn.edx.org/register → edxapp://enroll
  if (
    urlObj.hostname.includes("authn") &&
    (urlObj.pathname === "/register" || urlObj.pathname === "/login")
  ) {
    return `edxapp://enroll${urlSearch ? `?${urlSearch}` : ""}`;
  }

  if (coursePaths.some((path) => startsWithSubDirectory(urlPath, path))) {
    return `edxapp://course_info?path_id=${urlPath}${urlSearch ? `&${urlSearch}` : ""}`;
  }

  if (
    programPaths.some((path) => startsWithSubDirectory(urlPath, path, true))
  ) {
    return `edxapp://program_info?path_id=${urlPath}${urlSearch && `&${urlSearch}`}`;
  }

  if (startsWithSubDirectory(urlPath, "search")) {
    return `/webview/v2/${urlPath}${urlSearch && `?${urlSearch}`}&device=app&webview=true`;
  }

  // if its not a deep link, just fallback to the regular website
  return `/${urlPath}${urlSearch && `?${urlSearch}`}`;
};

export default getWebviewUrl;
